<style>
.add-owner {
    float: right;
}

.ranges {
    max-height: 200px;
    overflow: scroll;
}

.alert-primary {
    width: 100%;
}
</style>
<template>
  <div>
    <!-- Form Modal -->
    <b-modal
      id="modal-season-form"
      ref="myModal"
      centered
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
      @ok="submit"
    >
      <!-- Custom Modal Header -->
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <h5>Issue Tickets</h5>

        <feather-icon
          class="ml-4 pr-0 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="close()"
        />
      </template>

      <!-- Custom Modal Footer -->
      <template #modal-footer="{ ok, cancel }">
        <b-button
          size="sm"
          variant="primary"
          :disabled="saving"
          @click="ok()"
        >
          <b-spinner
            v-if="saving"
            small
            class="mr-1"
            label="Small Spinner"
          />
          <span v-if="!saving">Issue</span>
          <span v-if="saving">Issuing...</span>
        </b-button>
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>

      <!-- Data Form in Modal Body -->
      <template #default="{ }">

        <b-row>
          <b-col cols="12">
            <!-- <b-alert show variant="danger" v-if="errosOcurs" class="p-1">{{ errosOcurs.message }}</b-alert> -->

            <b-alert
              v-if="errosOcurs"
              show
              variant="danger"
            >
              <h4 class="alert-heading">
                {{ errosOcurs.message }}
              </h4>
              <div class="alert-body">
                <div
                  v-for="(errosOcurs, field) in errosOcurs.errors"
                  :key="field"
                >
                  <strong>{{ field }}:</strong>
                  <ul>
                    <li
                      v-for="message in errosOcurs"
                      :key="message"
                    >
                      {{ message }}
                    </li>
                  </ul>
                </div>
              </div>
            </b-alert>

          </b-col>
        </b-row>
        <validation-observer
          ref="dataForm"
          #default="{ invalid }"
        >
          <b-form
            ref="form"
            @submit.stop.prevent="handleCreate"
          >
            <b-row>

              <b-alert
                v-if="requisitionDetail.notes"
                show
                variant="primary"
              >
                <h4 class="alert-heading">
                  Requisition Number {{ requisitionDetail.number }}
                </h4>
                <div class="alert-body">
                  <ul>
                    <li>For Society <span style="font-weight:bold;">
                      {{ requisitionDetail.society.name }}</span>
                      at Sale {{ requisitionDetail.sale.number }} on {{
                        requisitionDetail.sale.market.name.toUpperCase() }} :- {{ requisitionDetail.sale.market.code }}</li>
                  </ul>

                  <Accordion>
                    <AccordionTab
                      v-for="note in requisitionDetail.notes"
                      :key="note.number"
                      :header="'Issue Note Number  ' + note.number"
                    >
                      <table class="table">
                        <thead>
                          <tr class="text-center">
                            <th>Start</th>
                            <th>End</th>
                            <!-- <th width="10%">Quantity</th> -->
                            <th width="3%" />
                          </tr>
                        </thead>
                        <tbody>

                          <tr
                            v-for="element, index in note.ranges"
                            :key="index"
                          >
                            <td scope="row">
                              <div>
                                <b-form-input
                                  id="start"
                                  v-model="element.start"
                                  name="start"
                                  size="sm"
                                />
                              </div>
                            </td>
                            <td>
                              <div>
                                <b-form-input
                                  id="end"
                                  v-model="element.end"
                                  name="end"
                                  size="sm"
                                />
                              </div>
                            </td>
                            <!-- <td v-if="role.id == 5">
                                                            <b-button variant="outline-danger" @click="deIssue(note.id)"  size="sm">
                                                                <feather-icon icon="TrashIcon" size="11"
                                                                    class="text-danger stroke-current" />
                                                            </b-button>
                                                        </td> -->

                            <td v-if="canDeissue">
                              <b-button
                                variant="outline-danger"
                                size="sm"
                                @click="deIssue(note.id)"
                              >
                                <feather-icon
                                  icon="TrashIcon"
                                  size="11"
                                  class="text-danger stroke-current"
                                />
                              </b-button>
                            </td>
                          </tr>
                          <tr>
                            <td scope="row" />
                            <td />
                            <td />
                          </tr>
                        </tbody>
                      </table>
                    </AccordionTab>

                  </Accordion>
                </div>
              </b-alert>
            </b-row>

            <b-row>
              <b-col>
                <b-button
                  size="sm"
                  class="add-owner mb-1"
                  variant="outline-primary"
                  @click="addElement()"
                >Add Range</b-button>

              </b-col>
              <table class="table">
                <thead>
                  <tr class="text-center">
                    <th>Start</th>
                    <th>End</th>
                    <th width="10%">
                      Quantity
                    </th>
                    <th width="3%" />
                  </tr>
                </thead>
                <tbody>

                  <tr
                    v-for="element, index in requisition.ranges"
                    :key="index"
                  >
                    <td scope="row">
                      <div>
                        <b-form-input
                          id="share"
                          v-model="element.start"
                          name="start"
                          size="sm"
                        />
                      </div>
                    </td>

                    <td>
                      <div>
                        <b-form-input
                          id="share"
                          v-model="element.end"
                          name="end"
                          size="sm"
                        />
                      </div>

                    </td>

                    <td>
                      <div>
                        <b-form-input
                          id="share"
                          v-model="element.quantity"
                          name="quantity"
                          size="sm"
                        />
                      </div>

                    </td>
                    <td>
                      <b-button
                        variant="outline-danger"
                        size="sm"
                        @click="removeRow(index)"
                      >
                        <feather-icon
                          icon="TrashIcon"
                          size="11"
                          class="text-danger stroke-current"
                        />
                      </b-button>
                    </td>
                  </tr>
                  <tr>
                    <td scope="row" />
                    <td />
                    <td />
                  </tr>
                </tbody>
              </table>
            </b-row>

            <!-- <pre>
                            {{ requisition }}
                        </pre> -->
          </b-form>
        </validation-observer>
      </template>

    </b-modal>
    <!-- ./Form Modal -->

    <!-- Form Modal -->
    <b-modal
      ref="myModalPcn"
      centered
      no-close-on-backdrop
      no-close-on-esc
      :hide-footer="true"
      size="xl"
    >
      <!-- Custom Modal Header -->
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <h5>Tickets Requisition</h5>
        <feather-icon
          class="ml-4 pr-0 cursor-pointer"
          icon="PrinterIcon"
          size="16"
          @click="getPcn(requisitionData)"
        />
        <feather-icon
          class="ml-4 pr-0 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="close()"
        />
      </template>

      <!-- Data Form in Modal Body -->
      <template #default="{ }">
        <b-row>
          <b-col>
            <h6 class="text-center">
              MKWAWA LEAF TOBACCO LIMITED
            </h6>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <p
              class="text-center"
              style="font-size: 12px"
            >
              PS TOBACCO BALE TICKETS REQUISITION & ISSUE NOTE  <span style="font-weight: 700; margin-left: 2%">NO <u>{{ requisitionData.number }}</u></span>
            </p>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="4">
            <p v-if="!requisitionData.sale.market.location.parent">
              REGION: <u>{{ requisitionData.sale.market.address.location.name.toUpperCase() }}</u>
            </p>
            <p v-else>
              REGION: <u>{{ requisitionData.sale.market.location.parent.name.toUpperCase() }}</u>
            </p>
            <p>AREA:_______________________</p>
            <p>MARKET CENTER: <u>{{ requisitionData.sale.market.name.toUpperCase() }}</u></p>
          </b-col>
          <b-col cols="4">
            <p>MARKET SEASON: <u>{{ requisitionData.sale.season.startYear }}/{{ requisitionData.sale.season.endYear }}</u></p>
            <p>SALE DATE:<u>  {{ requisitionData.sale.saleDateFormated }}</u></p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SALE No:<u> {{ (''+requisitionData.sale.number).padStart(2, '0') }}</u></p>
          </b-col>
          <b-col cols="4">
            <p>PRIMARY SOCIETY: <u>{{ requisitionData.society.name }}</u></p>
            <p>PS/ CHAIRMAN:___________________________</p>
            <p>SIGNATURE & STAMP:______________________</p>
          </b-col>
        </b-row>

        <table
          class="table table-responsive"
          style="width: 100%;"
        >
          <thead>
            <tr>
              <th
                scope="col"
                colspan="4"
              >
                Bales placed
              </th>
              <th
                scope="col"
                colspan="2"
              >
                Barcode From
              </th>
              <th
                scope="col"
                colspan="1"
              >
                Barcode To
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="note in requisitionData.notes"
              v-if="requisitionData.notes.length > 0"
            >
              <td colspan="4">
                {{ note.ranges[0].quantity }}
              </td>
              <td colspan="2">
                <span v-if="note">{{ note.ranges[0].start }} </span>
              </td>
              <td colspan="1">
                <span v-if="note">{{ note.ranges[0].end }}</span>
              </td>
            </tr>

            <tr v-if="requisitionData.notes.length == 0">
              <td colspan="4">
                {{ parseInt(requisitionData.summaries[0].quantity) }}
              </td>
            </tr>

          </tbody>

          <tfoot>
            <tr style="font-weight:bold;">
              <td
                class="footer"
                colspan="4"
              >
                <p>Verified by GT/RH Supervisor Name:______________________________</p>
                <p>Checked/counter signed by SO Name:____________________________</p>
                <p>Approved by AAC/RA Name:_______________________________________</p>
                <p>PCN generated by Name:_________________________________________</p>
                <p>Issued by Name:__________________________________________________</p>
                <p>Received by Name:_______________________________________________</p>
              </td>
              <td
                class="footer"
                colspan="2"
              >
                <p>Signature:_________________________</p>
                <p>Signature:_________________________</p>
                <p>Signature:_________________________</p>
                <p>Signature:_________________________</p>
                <p>Signature:_________________________</p>
                <p>Signature:_________________________</p>
              </td>
              <td class="footer">
                <p>Date:_________________________</p>
                <p>Date:_________________________</p>
                <p>Date:_________________________</p>
                <p>Date:_________________________</p>
                <p>Date:_________________________</p>
                <p>Date:_________________________</p>
              </td>
            </tr>
          </tfoot>

        </table>
        <b-row>
          <b-col cols="6">
            <p><span style="font-weight:bold">Distribution:    Original- Stores</span></p>
          </b-col>
          <b-col cols="6">
            <p><span style="font-weight:bold">1st copy- SO</span></p>
            <p><span style="font-weight:bold">2nd copy- P/society</span></p>
            <p><span style="font-weight:bold">3rd copy- Book copy</span></p>
          </b-col>
        </b-row>

        <!-- <b-row>
                        <b-col>
                            <p class="text-bold">TMP 003/22</p>
                        </b-col>
                    </b-row> -->
      </template>
    </b-modal>
    <!-- ./Form Modal -->

    <!-- Form Modal -->
    <b-modal
      id="modal-season-form"
      ref="myViewModal"
      centered
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
      @ok="submit"
    >
      <!-- Custom Modal Header -->
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <h5>Issued Tickets</h5>

        <feather-icon
          class="ml-4 pr-0 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="close()"
        />
      </template>

      <!-- Custom Modal Footer -->
      <template #modal-footer="{ ok, cancel }">
        <b-button
          size="md"
          variant="primary"
          :disabled="saving"
          @click="ok()"
        >
          <b-spinner
            v-if="saving"
            small
            class="mr-1"
            label="Small Spinner"
          />
          <span v-if="!saving">Issue</span>
          <span v-if="saving">Issuing...</span>
        </b-button>
        <b-button
          size="md"
          variant="outline-secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>

      </template>

      <!-- Data Form in Modal Body -->
      <template #default="{ }" />

    </b-modal>
    <!-- ./Form Modal -->

    <!-- Filters -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>Filter Location</h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            md="12"
          >
            <location-filters
              size="sm"
              align="horizontal"
              @filter="changeFilters"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col
            v-if="locId !== null && locId.id > 0"
            cols="3"
          >
            <b-form-group
              labe-for="market_id"
              label="Market Center"
            >
              <validation-provider
                #default="{ errors }"
                name="Market Center"
                rules=""
              >
                <b-form-select
                  id="market_id"
                  v-model="filter.market_id"
                  name="market_id"
                  size="sm"
                  @change="getAreaMarketSale(filter.market_id)"
                >
                  <b-form-select-option :value="null">
                    Select...
                  </b-form-select-option>
                  <b-form-select-option
                    v-for="market in markets"
                    :key="market.id"
                    :value="market.id"
                  >
                    {{ market.name.toUpperCase() }}
                  </b-form-select-option>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <small
                  v-if="serverErrors && serverErrors.market_id"
                  class="text-danger"
                >{{
                  serverErrors.market_id[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              labe-for="sale_id"
              label="Sale"
            >
              <validation-provider
                #default="{ errors }"
                name="Sale"
                rules=""
              >
                <b-form-select
                  id="sale_id"
                  v-model="filter.sale_id"
                  name="sale_id"
                  size="sm"
                  @change="changeSale($event)"
                >
                  <b-form-select-option :value="null">
                    Select...
                  </b-form-select-option>
                  <b-form-select-option
                    v-for="sale in sales"
                    :key="sale.id"
                    :value="sale"
                  >
                    {{ sale.number }}
                  </b-form-select-option>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <small
                  v-if="serverErrors && serverErrors.sale_id"
                  class="text-danger"
                >{{
                  serverErrors.sale_id[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              labe-for="society_id"
              label="Society"
            >
              <validation-provider
                #default="{ errors }"
                name="Society"
                rules=""
              >
                <b-form-select
                  id="society_id"
                  v-model="filter.society_id"
                  name="society_id"
                  size="sm"
                  @change="changeSociet(filter.society_id)"
                >
                  <b-form-select-option :value="null">
                    Select...
                  </b-form-select-option>
                  <b-form-select-option
                    v-for="society in societies"
                    :key="society.id"
                    :value="society.id"
                  >
                    {{ society.name }}
                  </b-form-select-option>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <small
                  v-if="serverErrors && serverErrors.society_id"
                  class="text-danger"
                >{{
                  serverErrors.society_id[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="sale !== null && sale.live">
          <b-col cols="3">
            <b-form-group
              label-for="requestTicket"
              label="Do you wish to request Ticket?"
            >
              <b-form-checkbox
                v-model="requestTicket"
                class="custom-control-success ml-4"
                name="check-button"
                switch
                @change="handleChange($event)"
              >
                <span class="switch-icon-left">
                  <feather-icon icon="CheckCircleIcon" />
                </span>
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col
            v-if="requestTicket"
            cols="3"
          >
            <b-form-group
              label-for="quantity"
              label="Quantity"
            >
              <b-form-input
                id="quantity"
                ref="quantity"
                v-model="requestForm.quantity"
                name="quantity"
                size="sm"
              />
            </b-form-group>
          </b-col>

          <b-col
            v-if="requestTicket"
            cols="3"
            class="pt-2"
          >
            <b-form-group
              labe-for=""
              label=""
            >
              <b-button
                size="sm"
                variant="primary"
                :disabled="saving"
                @click="submitRequest()"
              >
                <b-spinner
                  v-if="saving"
                  small
                  class="mr-1"
                  label="Small Spinner"
                />
                <span v-if="!saving">Save</span>
                <span v-if="saving">Saving...</span>
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- <pre>{{requestForm}}</pre> -->
      </b-card-body>
    </b-card>
    <!-- ./Filters -->

    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50 select-size-sm"
            />
            <label>entries</label>
          </b-col>
          <!-- ./Per Page -->

          <!-- Search & Button -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
                size="sm"
              />
            </div>
          </b-col>
          <!-- ./Search & Button-->
        </b-row>
        <!-- ./Table Top -->
      </div>

      <!-- Table -->
      <b-table
        ref="records"
        striped
        hover
        small
        class="position-relative"
        :items="fetch"
        responsive
        :fields="columns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(address)="data">
          {{ data.item.address ? data.item.address.location.name.toUpperCase() : '' }}
        </template>

        <template #cell(approved)="data">
          <!-- <b-badge pill :variant="`light-${resolveStatusVariant(data.item.approved)}`" class="text-capitalize">
                        <span v-if="data.item.approved == true">Yes</span>
                        <span v-else-if="data.item.approved == false">No</span>
                    </b-badge> -->

          <b-form-checkbox
            class="custom-control-success ml-4"
            name="check-button"
            switch
            :checked="data.item.approved"
            :disabled="permissions.filter(e => e.action === 'approve-requisitions').length < 1"
            @change="handleCheckboxChange($event, data.item.id)"
          >
            <span class="switch-icon-left">
              <feather-icon icon="CheckCircleIcon" />
            </span>
          </b-form-checkbox>
        </template>

        <template #cell(description)="data">
          <span
            v-if="data.item.summaries.length"
            class="text-nowrap"
          >
            {{ data.item.summaries[0].description }}
          </span>
        </template>

        <template #cell(market)="data">
          <span class="text-nowrap">
            {{ data.item.sale.market.name }}
          </span>
        </template>

        <template #cell(sale)="data">
          <span class="text-nowrap">
            {{ data.item.sale.number }}
          </span>
        </template>

        <template #cell(society)="data">
          <span class="text-nowrap">
            {{ data.item.society.name }}
          </span>
        </template>

        <template #cell(summaries)="data">
          <span
            v-if="data.item.summaries.length"
            class="text-nowrap"
          >
            {{ parseInt(data.item.requestedQuantity).toLocaleString() }}
          </span>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            v-if="permissions.filter(e => e.action === 'issue-tickets' || e.action === 'ticket-requisition-view').length > 0"
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="data.item.approved && permissions.filter(e => e.action === 'issue-tickets').length > 0"
              @click="invokeCreateForm(data.item)"
            >
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Issue Tickets</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="data.item.approved === false && permissions.filter(e => e.action === 'approve-requisitions').length > 1"
              @click="approveRequisition(data.item)"
            >
              <feather-icon icon="CheckIcon" />
              <span class="align-middle ml-50">Approve Requisition</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="permissions.filter(e => e.action === 'ticket-requisition-view').length > 0"
              @click="viewRequisition(data.item)"
            >
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">View Requisition</span>
            </b-dropdown-item>

          </b-dropdown>
        </template>
      </b-table>

      <!-- Table Footer -->
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ from }} to {{ to }} of {{ totalRecords }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRecords"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
    BRow, BCol, BCard, BCardHeader, BCardBody, BTable, BPagination,
    BForm, BFormGroup,
    BButton, BFormSelect, BFormSelectOption, BFormInput, BDropdown, BDropdownItem,
    BSpinner, BFormCheckbox, BBadge, BAlert,
} from 'bootstrap-vue'
import LocationFilters from '@core/components/cromis/filters/LocationFilters.vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import store from '@/store'
import {
    ref, onUnmounted, onMounted, reactive,
} from '@vue/composition-api'

import requisitionsStoreModule from '@/views/cromis/sales/requisition/requisitionsStoreModule'
import useRequisitionsList from '@/views/cromis/sales/requisition/useRequisitionsList'
import Panel from 'primevue/panel'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BCardHeader,
        BCardBody,
        BTable,
        BPagination,
        BForm,
        BFormGroup,
        BButton,
        BFormSelect,
        BFormSelectOption,
        BFormInput,
        vSelect,
        BDropdown,
        BDropdownItem,
        BSpinner,
        ValidationObserver,
        ValidationProvider,
        BFormCheckbox,
        BBadge,
        BAlert,
        Panel,
        Accordion,
        AccordionTab,
        LocationFilters,
    },
    directives: {},
    props: {},
    watch: {
        userInput(newInput, oldInput) {
            // Update default value when user input changes
            if (!isNaN(newInput)) {
                this.defaultValue -= (newInput - oldInput)
            } else {
                // Handle case where userInput is NaN (e.g., after deleting the number)
                this.defaultValue = this.defaultValue
            }
        },
    },
    setup(props, context) {
        const dataForm = ref(null)
        const myModal = ref(null)
        const myViewModal = ref(null)
        const myModalPcn = ref(null)
        const myRangeModal = ref(null)
        const canDeissue = ref(false)
        const saving = ref(false)
        const serverErrors = ref(null)
        const errosOcurs = ref(null)
        const selections = ref([])
        const formSelections = ref([])
        const levels = ref(null)
        const requisitionData = ref(null)
        const companies = ref([])
        const societies = ref([])
        const markets = ref([])
        const requisitionDetail = ref(null)
        const locations = ref([])
        const sales = ref([])
        const sale = ref(null)
        const tikets = ref([])
        const totalWeight = ref(0)
        const tValue = ref(0)
        const children = ref([])
        const requestTicket = ref(false)
        const permissions = ref(JSON.parse(localStorage.getItem('userData')).permissions)

        const requisition = ref({
            requisition_id: null,
            type: null,
            ranges: [
                {
                    start: null,
                    end: null,
                    quantity: null,
                },
            ],
        })
        const filter = ref({
            region_id: null,
            location_id: null,
            market_id: null,
            sale_id: null,
            society_id: null,
        })
        const requestForm = ref({
            tickets: true,
            quantity: null,
            sale_id: null,
            society_id: null,
        })

        const range = ref({
            id: null,
            requisition_id: null,
            number: null,
            start: null,
            end: null,
            quantity: null,
            hasMissing: false,
            lastBarcode: null,
            direction: null,
            count: null,
        })

        const locId = ref(JSON.parse(localStorage.getItem('userData')).station.location)
        const role = ref(JSON.parse(localStorage.getItem('userData')).roles[0])

        const addElement = () => {
            requisition.value.ranges.push({ start: '', end: '', quantity: '' })

            if (requisition.value.ranges.length > 0) {
                console.log(requisition.value.ranges)
            }
        }

        const handleChange = async event => {
            requestTicket.value = event
        }

        const submitRequest = async () => {
            saving.value = true
            console.log(requestForm.value)

            await store.dispatch('cromis-requisition/request', requestForm.value)
                .then(response => {
                    refetch()
                    saving.value = false

                    context.root.$swal({
                        icon: 'success',
                        text: 'Ticket request initialized successfully!',
                        showConfirmButton: true,
                        timer: 5000,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    console.log(error)
                    saving.value = false
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const deIssue = async id => {
            console.log(id)
            const payload = {
                id,
            }

            await store.dispatch('cromis-requisition/deIssue', { data: payload })
                .then(response => {
                    console.log(response)
                    refetch()
                    saving.value = false

                    context.root.$swal({
                        icon: 'success',
                        text: 'De issue has been successfully!',
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    console.log(error)
                    errosOcurs.value = error.response.data
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const removeRow = index => {
            console.log(index)
            if (requisition.value.ranges.length > 1) {
                requisition.value.ranges.splice(index, 1)
                requisition.value.ranges = requisition.value.ranges
            }
        }

        const CROMIS_STORE_MODULE_NAME = 'cromis-requisition'
        // Register module
        if (!store.hasModule(CROMIS_STORE_MODULE_NAME)) store.registerModule(CROMIS_STORE_MODULE_NAME, requisitionsStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(CROMIS_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_STORE_MODULE_NAME)
        })

        onMounted(async () => {
            canDeissue.value = permissions.value.filter(permission => permission.action === 'de-issue-tickets').length > 0

            await store.dispatch('cromis-requisition/locations')
                .then(response => {
                    locations.value = response.data.locations
                })
                .catch(error => {
                    console.log('got error', error)
                })

            await store.dispatch('cromis-requisition/markets', { location_id: filter.value.location_id })
                .then(response => {
                    markets.value = response.data.markets
                })
                .catch(error => {
                    console.log('got error', error)
                })
        })

        const handleCheckboxChange = async (event, id) => {
            const payload = {
                approved: event,
            }

            await store.dispatch('cromis-requisition/update', { id, data: payload })
                .then(response => {
                    refetch()
                    saving.value = false

                    context.root.$swal({
                        icon: 'success',
                        text: 'Changes to Requisition has been saved successfully!',
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    console.log(error)
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const populateSelections = locations => {
            for (let i = 0; i < locations.length; i++) {
                for (let x = 0; x < selections.value.length; x++) {
                    if (locations[i].level.name.toLowerCase() === selections.value[x].level) {
                        selections.value[x].locations.push(locations[i])

                        if (x === 0) {
                            formSelections.value[x].locations.push(locations[i])
                        }
                    }
                }
            }
        }

        const changeFilters = async filteredLocation => {
            requisition.value.location_id = filteredLocation !== null ? filteredLocation.id : null
            locationFilter.value = filteredLocation !== null ? filteredLocation.id : null

            await store.dispatch('cromis-requisition/markets', { location_id: filteredLocation !== null ? filteredLocation.id : null })
                .then(response => {
                    markets.value = response.data.markets
                })
                .catch(error => {
                    console.log(error)
                })
        }

        const viewRequisition = item => {
            requisitionData.value = item

            requisitionData.value.notes.forEach(ele => {
                ele.ranges.forEach(ra => {
                    ele.ranges[0].quantity = parseInt(ra.end.slice(0, -1) - ra.start.slice(0, -1) + 1)
                })
            })

            // console.log(requisitionData.value)
            myModalPcn.value.show()
        }

        const getPcn = async () => {
            // console.log(requisitionData.value.id)
            const data = {
                requisition_id: requisitionData.value.id,
                report_id: 5,
            }
            // console.log(data)

            await store.dispatch('cromis-requisition/saleReport', data)
                .then(response => {
                    context.root.$swal({
                        icon: 'success',
                        text: 'Ticket Requisition prints initialized!',
                        showConfirmButton: true,
                        timer: 5000,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    console.log(error)
                    saving.value = false
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const {
            fetch,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,

            // Filers
            resolveStatusVariant,
            resolveReceivedVariant,
            locationFilter,
            societyFilter,
            marketFilter,
        } = useRequisitionsList()

        // Form Methods
        const invokeUpdateForm = item => {
            serverErrors.value = null
            errosOcurs.value = null

            requisition.value = {
                requisition_id: item.id,
                type: item.type,
                location_id: null,
                ranges: item.ranges,
            }

            myModal.value.show()
        }

        const invokeCreateForm = item => {
            formSelections.value.map(form => {
                form.model = null
            })
            requisitionDetail.value = item
            console.log(requisitionDetail.value)
            requisition.value = {
                requisition_id: item.id,
                ranges: [
                    {
                        start: null,
                        end: null,
                        quantity: null,
                    },
                ],
            }

            myModal.value.show()
        }

        const approveRequisition = item => {
            console.log(item)
            handleApprove(item)
        }

        const invokeRangeUpdateForm = par => {
            formSelections.value.map(form => {
                form.model = null
            })

            console.log(par)

            range.value = {
                id: par.ranges[0].id,
                requisition_id: par.id,
                number: par.number,
                start: par.ranges[0].start,
                end: par.ranges[0].end,
                quantity: par.ranges[0].quantity,
                hasMissing: null,
                lastBarcode: null,
                direction: null,
                count: null,
            }

            myRangeModal.value.show()
        }

        const getAreaMarket = async () => {
            locationFilter.value = filter.value.location_id

            await store.dispatch('cromis-requisition/markets', { location_id: filter.value.location_id })
                .then(response => {
                    markets.value = response.data.markets

                    console.log(response)
                })
                .catch(error => {
                    console.log('got error', error)
                })
        }

        const getAreaMarketSale = async () => {
            marketFilter.value = filter.value.market_id
            await store.dispatch('cromis-requisition/sales', { market_id: filter.value.market_id })
                .then(response => {
                    sales.value = response.data.sales
                    societies.value = response.data.sales.societies
                    console.log(response)
                })
                .catch(error => {
                    console.log('got error', error)
                })
        }

        const changeSociet = async id => {
            societyFilter.value = id
            requestForm.value.society_id = id
        }

        const changeSale = async event => {
            societies.value = event.societies
            requestForm.value.sale_id = event.id

            sale.value = event

            console.log(sale.value)
        }

        const changeRegion = async event => {
            console.log(event)
            locId.value = event
            locationFilter.value = event.id

            await store.dispatch('cromis-requisition/markets', { location_id: locId.value !== null ? locId.value.id : null })
                .then(response => {
                    markets.value = response.data.markets

                    console.log(response)
                })
                .catch(error => {
                    console.log('got error', error)
                })
        }

        const isFormValid = async () => {
            let isValid = false
            await dataForm.value.validate().then(success => {
                isValid = success
            })

            return isValid
        }

        const submit = bvModalEvt => {
            bvModalEvt.preventDefault()

            serverErrors.value = null
            handleCreate()
        }

        const submitUpdateRange = bvModalEvt => {
            bvModalEvt.preventDefault()

            serverErrors.value = null
            handleUpdateRange(range.value)
        }

        const handleCreate = async () => {
            serverErrors.value = null
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
                return
            }

            await store.dispatch('cromis-requisition/requisition', requisition.value)
                .then(response => {
                    refetch()
                    saving.value = false

                    myModal.value.hide()

                    context.root.$swal({
                        icon: 'success',
                        text: 'Ticket has been issued successfully!',
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    errosOcurs.value = error.response.data
                    saving.value = false

                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const handleApprove = async item => {
            saving.value = true

            const data = {
                approved: true,
            }

            console.log(item)
            console.log(data)

            await store.dispatch('cromis-requisition/update', { id: item.id, data })
                .then(response => {
                    refetch()
                    saving.value = false

                    context.root.$swal({
                        icon: 'success',
                        text: 'Approved has been made successfully!',
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    errosOcurs.value = error.response.data
                    console.log(error.response)
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors

                        console.log(serverErrors)
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const handleUpdateRange = async item => {
            console.log(item)
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
                return
            }

            await store.dispatch('cromis-requisition/range', { id: item.id, data: item })
                .then(response => {
                    refetch()
                    saving.value = false

                    myModal.value.hide()

                    context.root.$swal({
                        icon: 'success',
                        text: 'Changes to requisition range has been saved successfully!',
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    errosOcurs.value = error.response.data
                    console.log(error.response)
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors

                        console.log(serverErrors)
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const handleUpdate = async item => {
            console.log(item)
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
                return
            }

            await store.dispatch('cromis-requisition/update', { id: item.id, data: item })
                .then(response => {
                    refetch()
                    saving.value = false

                    myModal.value.hide()

                    context.root.$swal({
                        icon: 'success',
                        text: `Changes to requisition center ${response.data.code} ${response.data.name} has been saved successfully!`,
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    errosOcurs.value = error.response.data
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const confirmDelete = async id => {
            const result = context.root.$swal({
                icon: 'info',
                title: 'System Info',
                text: 'Are you sure you want to delete the Box?',
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel',
                customClass: {
                    confirmButton: 'btn btn-info',
                    cancelButton: 'btn btn-danger ml-2', // Optional: Customize the cancel button class
                },
                buttonsStyling: true,
            }).then(result => {
                if (result.value) {
                    remove(id)
                } else {
                    context.root.$swal({
                        icon: 'info',
                        title: 'Cancelled',
                        text: 'Your Box is safe you cancell deletion of it',
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-info',
                        },
                        buttonsStyling: true,
                    })
                }
            })
        }
        const deleteItem = async () => {
            context.root.$swal({
                icon: 'info',
                title: 'Cancelled',
                text: 'Your Box is safe you cancell deletion of it',
                showConfirmButton: true,
                customClass: {
                    confirmButton: 'btn btn-info',
                },
                buttonsStyling: true,
            })
        }

        const remove = async id => {
            await store.dispatch('cromis-requisition/remove', id)
                .then(response => {
                    refetch()
                })
                .catch(error => {
                    context.root.$swal({
                        icon: 'error',
                        title: 'Server Error',
                        text: 'Something went wrong. See tech support',
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: true,
                    })
                })
        }

        return {
            // Data
            selections,
            formSelections,
            levels,
            children,
            requisition,
            range,
            selectedOwner: null,
            addedElement: null,
            clientName: JSON.parse(localStorage.getItem('userData')).client,
            options: [
                { value: null, text: '-- Select Box Type --' },
                { value: '1', text: 'Bale Ticket' },
                { value: '2', text: 'Luggage' },
            ],
            permissions,
            fetch,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,
            resolveStatusVariant,
            resolveReceivedVariant,
            viewRequisition,
            // Methods

            required,
            saving,
            serverErrors,
            dataForm,
            myModal,
            myModalPcn,
            myViewModal,
            requisitionDetail,
            filter,
            canDeissue,
            markets,
            locations,
            sales,
            sale,
            changeSale,
            changeSociet,
            changeRegion,
            myRangeModal,
            changeFilters,
            locationFilter,
            societyFilter,
            marketFilter,
            invokeCreateForm,
            invokeUpdateForm,
            invokeRangeUpdateForm,
            approveRequisition,
            submit,
            submitUpdateRange,
            isFormValid,
            handleCreate,
            handleUpdate,
            handleUpdateRange,
            remove,
            addElement,
            removeRow,
            companies,
            societies,
            confirmDelete,
            deleteItem,
            errosOcurs,
            locId,
            role,
            getAreaMarket,
            getAreaMarketSale,
            handleApprove,
            handleCheckboxChange,
            tikets,
            totalWeight,
            tValue,
            requisitionData,
            getPcn,
            deIssue,
            handleChange,
            requestTicket,
            requestForm,
            submitRequest,
        }
    },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
</style>
